import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface PieChartProps {
  data: Array<{ name: string; value: number }>;
  donut?: boolean;
  height?: number | string;
  loading?: boolean;
  color?: string;
}

export function PieChart({ data, donut = true, height, loading, color }: PieChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    legend: { bottom: 0 },
    series: [
      {
        type: 'pie',
        radius: donut ? ['40%', '70%'] : '70%',
        avoidLabelOverlap: false,
        label: { show: true, formatter: '{b}: {d}%' },
        data: color
          ? data.map((d) => ({ ...d, itemStyle: { color } }))
          : data,
      },
    ],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
